import { useCallback } from 'react'
import * as React from 'react'
import { useIntl } from 'react-intl'

import ModalBase from 'LuxKit/Modal/ModalBase'
import ModalContent from 'LuxKit/Modal/ModalContent'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import ModalFooter from 'LuxKit/Modal/ModalFooter'

import BodyText from 'LuxKit/Typography/BodyText'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import PriceChangeViewV2 from 'components/Common/PriceChangeView/PriceChangeViewV2'

interface Props {
  oldDisplayPrice: number
  newDisplayPrice: number
  oldPropertyFees: number
  newPropertyFees: number
}

function BedbankChangePriceModal({
  oldDisplayPrice,
  newDisplayPrice,
  oldPropertyFees,
  newPropertyFees,
}: React.PropsWithChildren<Props>) {
  const intl = useIntl()
  const { resolve } = useModalElementContext<boolean | undefined>()

  const onAcceptNewPrice = useCallback(() => resolve(true), [resolve])

  return (
    <ModalBase size="S">
      <ModalHeader
        title={intl.formatMessage({
          id: 'qhW58L0B7zajX4-r2CrR',
          defaultMessage: 'Price Update',
          description: 'Modal title when bedbank package price has changed',
        })}
      />
      <ModalBody>
        <ModalContent>
          <VerticalSpacer gap={24}>
            <BodyText as="p" variant="large">
              {intl.formatMessage({
                id: 'kclsBhMgyYzHO8l5FniK',
                defaultMessage: 'The price of your package has changed due to updated availability. Please review the new price and accept it to continue.',
                description: 'Message informing user the package price changed and asking them to review',
              })}
            </BodyText>
            <PriceChangeViewV2
              oldPrice={oldDisplayPrice}
              newPrice={newDisplayPrice}
              oldPropertyFees={oldPropertyFees}
              newPropertyFees={newPropertyFees}
            />
          </VerticalSpacer>
        </ModalContent>
      </ModalBody>
      <ModalFooter
        primaryActionProps={{
          children: intl.formatMessage({
            id: 'Jcu4vXopHpRWqYdcREUw',
            defaultMessage: 'Accept updated price',
            description: 'Button text to accept updated price in the date selection or calendar picker',
          }),
          onClick: onAcceptNewPrice,
        }}
        secondaryActionProps={{
          children: intl.formatMessage({
            id: 'QlVrRs1a8O2rhHcsF70G',
            defaultMessage: 'Return to offer',
            description: 'Button text to return to offer on the offer listing or detail page',
          }),
        }}
      />
    </ModalBase>
  )
}

export default BedbankChangePriceModal
